import React ,{useRef ,useEffect}from 'react';
import moment from 'moment'
import IrtizaDynamicInputList from '../dynamic-input/dynamic-input-list';
import IrtizaDynamicInputAddNewList from '../dynamic-input/dynamic-input-add-new-list';
import SecurityService from '../security/security.service';
import BrandAdd  from './brand-add'
import BrandService from './brand.service';
import AuditTableInput from '../audit-table/audit-table'
import './brand.scss'


const BrandInput = (props) => {



// BrandID
// BrandName
    let columns =[
        {  field: "BrandID",headerText:'ID',width:'90px',textAlign:'right' ,headerTextAlign:'center',other:[{allowEditing:false}]},
        {  field: "BrandName",headerText:'Brand Name',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        {  field: "BrandVendorName",headerText:'Brand Vendor Name',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        ]

       const listActionComplete = async (grid , args ,getListService ,selectedRow )=>{
        console.log(args )
        console.log(getListService )
        console.log(selectedRow )
        if (args.requestType === 'beginEdit' || args.requestType === 'add') {
          // if(args.requestType == 'add'){
          //   setTimeout(()=>document.getElementById('BrandGridBrandName').focus(),400)
          // }
          // document.getElementById('BrandGridBrandName').addEventListener('blur', async (e)=>{
          //   setTimeout(() => document.getElementById('BrandGridBrandName') && grid?.endEdit(), 200);
           
          // })
          }
        if (args.requestType == 'save' || args.requestType == 'cancel' ) {
          getListService()

        }
        if(args.requestType == 'save'){
          let data = {
            BrandID:args.data.BrandID,
            BrandName:args.data.BrandName,
            BrandVendorID:args.data.BrandVendorID
          }
          console.log(data)
        if(args.action == 'add'){
          BrandService.insert(data).then(async (res)=>{
            await getListService()
            // setTimeout(()=>document.getElementById('BrandGrid_add').click(),700)

            // let AddData = {
            //   BrandID:args.data.BrandID,
            //   BrandName:args.data.BrandName,
            // }
            // AuditTableInput.auditAdd(`Brand`,`Brand`,`BrandID`,AddData)
          })
        }
        if(args.action == 'edit'){
          BrandService.update(data).then((res)=>{
            getListService()

            // let EditData = {
            //     BrandID:args.data.BrandID,
            //     BrandName:args.data.BrandName
            // }
            // let totalColumns = Object.keys(EditData);
            //             console.log(totalColumns)
            //             AuditTableInput.auditEdit(totalColumns,selectedRow,EditData,`Brand`,args.data.MainBrandID)
          })
        }
        }
        
       }
       //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************

        // Defines the  boolean
        // @default true
    let  allowTemplate = true
    let  allowGrouping = true
    let  allowExcelExport =true
    let  allowPdfExport = true
    let  showColumnChooser = true
    let  allowPaging = false
    let  allowDataBound = true
    let  allowGridSum = false
    let  isDialog = props.IsDialog == true ? true : false

       
        // Defines the  string
        // @default Brand${typeMode} 
        let ListSecurity='JournalVoucherList'
        let AddSecurity='JournalVoucherList'
        let EditSecurity='JournalVoucherList'
        let DeleteSecurity='JournalVoucherList'
       
       // Defines the  ['Add','Edit','Delete','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'] | 'All'
       //  @default 'All'
      let toolbarOptions ='All';

      const toolbarClicking =  async (args)=>{
        console.log(args)
      }
      
       // Defines the 'Descending' | 'Ascending'
       //  @default 'Descending'
      let DefaultSortedColumnSort ='Descending';

       /* Defines the [{
                    TableName:'Brand' ,
                    TableID:'BrandID',
                   // Optional if Delete is Soft // TableSecurity:'BrandDelete',
                }]*/
    //  @default [] 
    //   let listDelete =  [{ TableName:'Brand' ,TableID:'BrandID', Optional // TableSecurity:'BrandDelete'}]
    let listDelete = [];
       
    // Defines 'Hard' | 'Soft' 
    // @Default 'Hard'
    let deleteType = 'Hard'


/* Defines the [   {field:'IsDeleted',
OPTIONAL HAI operator:'equal' or more check syncfusion documentation
        value:'No'},...more
        ] | []
      @default [] */
    //   let filterColumns = [{ field: 'IsDeleted', value: 'No' }];
      let filterColumns = [];

      /* Defines the [ColumnNames] | []
      @default [] */
    //   let groupColumns = ['IsDeleted','AccountTitleHawalaDr'];
      let groupColumns = [];

/* Defines the 'Dialog' | 'Normal'
      @default 'Dialog' */
      let gridEditSettingMode = 'Dialog';

/* Defines the '<p></p>' | Can give HTML | AND REACT FUNCTION LIKE HeaderTemplate
      @default '<p></p>' */
      let gridEditSettingHeaderTemplate = '<p></p>';

      /* Defines the  [ColumnNames] | []
      @default [] */
           //   let gridSumColumns = ['HawalaCommissionPercent'];
      let gridSumColumns = [];


    return (
      
        <IrtizaDynamicInputList
        Id='Brand'
        ListTitle='Brand  - List'
        ColumnsList={columns}
        GridDataSource= {[
                    {
                        DataSourceType: 'Function',
                        // DataSource:  ()=> BrandService.getBrandForList()
                        DataSource:  ()=> BrandService.getBrandForList()
                        }]}
        DefaultSortedColumnName={'BrandID'}
        GridDialog={[
            {
                DialogType:'Self',
                Dialog:<BrandAdd ShopID={SecurityService.getLoggedInShopID()} />
        
            }
        ]}
        ListActionComplete={listActionComplete}
        ToolbarClicking ={toolbarClicking}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
            // AllowTemplate={allowTemplate}
            // ToolbarOption={toolbarOptions}
            // AllowGrouping={allowGrouping}
            // AllowExcelExport={allowExcelExport}
            // AllowPdfExport={allowPdfExport} 
            // ShowColumnChooser={showColumnChooser}
            // AllowPaging={allowPaging}
            AllowDataBound={allowDataBound}
            // ListSecurity={ListSecurity}
            // AddSecurity={AddSecurity}
            // EditSecurity={EditSecurity}
            // DeleteSecurity={DeleteSecurity}
            // DefaultSortedColumnSort={DefaultSortedColumnSort}
            // FilterColumns={filterColumns} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
            // GroupColumns={groupColumns} 
            // ListDelete={listDelete}
            // DeleteType={deleteType} 
            GridEditSettingMode={gridEditSettingMode}
            // GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
            // GridSumColumns={gridSumColumns}
            // AllowGridSum={allowGridSum}
            IsDialog={isDialog}

            {...props}
            ></IrtizaDynamicInputList>

            );
}



export default BrandInput;
